export const dashboardCleanKeys: Record<string, string> = {
  PaystubSummaryCollection: 'left',
  PaystubDetailCollection: 'right',
};

export const netIncomeCleanKeys: Record<string, string> = {
  EmployeeDeductions: 'deductions',
  EmployeeEarnings: 'earnings',
};

export const paystubDetailsCleanKeys: Record<string, string> = {
  PreTaxDeductionsDetail: 'preTaxDeduction',
  PostTaxDeductionsDetail: 'postTaxDeduction',
  EarningsDetail: 'earnings',
  BenefitsDetail: 'benefits',
  TaxesDetail: 'taxes',
  PaymentDetails: 'payment',
};

export const checksCleanKeys: Record<string, string> = {
  Checks: 'checks',
};

export const profileCleanKeys: Record<string, string> = {
  PersonalInformation: 'personal',
  BankAccountsInformation: 'bankAccounts',
  FederalTaxInformation: 'federalTax',
  StateTaxInformation: 'stateTax',
  EmployerReadyStates: 'employerReadyStates',
};

export const taxFormsCleanKeys: Record<string, string> = {
  TaxFormInfos: 'taxForms',
};

export const taxFormsNoticeCleanKeys: Record<string, string> = {
  TaxFormInfo: 'taxFormsNotice',
};
